<template lang="pug">
  div.container-cadastro
    .card-header.marginTitle
      h1 {{ titleCadastro }}
    .content
      el-tabs(v-if="!isIntroPasso && !isResumo", :value="menu" @tab-click="mudarTab")
        template(v-if="tab.label != 'Resumo'" v-for="tab in tabs")
          el-tab-pane(:name="tab.name")
            span.tab(slot="label")
              | {{tab.label}} &nbsp
              el-tooltip(effect='light', placement='bottom', v-if="tabPossuiErro(tab.label)")
                span(slot="content")
                  p(v-for="erro in getErrosTab(tab.label)")
                    pre
                      | {{erro}}
                i.el-icon-warning.tooltip-icon

      div.container-tab
        validation-observer(ref='observer' tag='form')
          keep-alive
            router-view(
              v-if="!isLoading && idProcesso !== null"
              :cadastro="cadastroJson"
              :idProcesso="idProcesso"
              :observer="this.$refs.observer"
            )
    app-buttons-cadastro-sicarf-retificacao(
      :isPrimeiroPasso="isPrimeiroPasso",
      :isUltimoPasso="isResumo",
      :isIntroPasso="isIntroPasso"
      :showButtonProximo="!isResumo"
      :showButtonSalvar="true",
      @proximo="proximo",
      @salvar="salvarCadastro",
      @voltar="voltar",
      @cancelar="cancelar",
      @finalizar="finalizarCadastro"
    )

</template>

<script>
import AppButtonsCadastroSicarfRetificacao from './AppButtonsCadastroSicarfRetificacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { cloneDeep, pickBy, identity } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import TermoCompromissoSicarf from './cadastro/TermoCompromissoSicarf'

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppButtonsCadastroSicarfRetificacao,
    TermoCompromissoSicarf
  },

  props: {
    titleCadastro: {
      type: String,
      required: true
    },

    routeName: {
      type: String,
      required: true
    },

    cadastroEmpty: {
      type: Object,
      required: false
    },

    tabs: {
      type: Array,
      required: true
    },
    cadastroJson: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      isLoading: false,
      cadastro: cloneDeep(this.cadastroEmpty),
      idCadastro: 0,
      showTermoCompromisso: false,
      isRetificacao: false,
      idProcesso: null,
      indexTabAtualValue: null,
      isPa: process.env.ESTADO === 'pa'
    }
  },

  async created () {
    this.isRetificacao = this.$route.params?.isRetificacao || false
    this.idProcesso = this.$route.params.id
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado',
      cadastroFormulario: 'retificacao/cadastro',
      versao: 'retificacao/versao',
      tipo: 'retificacao/tipo'
    }),

    indexTabAtual: {
      get () {
        return this.tabs.findIndex((tab) => tab.name === this.$route.name)
      },
      set (value) {
        this.indexTabAtual = value
      }
    },

    menu () {
      return this.$route.name
    },

    isPrimeiroPasso () {
      return this.indexTabAtual === 0
    },

    isIntroPasso () {
      return this.$route.meta && this.$route.meta.isIntro
    },

    isResumo () {
      return this.$route.meta && this.$route.meta.isResumo
    },

    isUltimoPasso () {
      return this.$route.name === 'retificacao/georreferenciamento'
    },

    tabsFiltered () {
      return this.tabs.filter(item => !item.isResumo && !item.isIntro)
    }
  },

  async beforeRouteUpdate (to, from, next) {
    this.validarCampos()
    next()
  },

  methods: {
    ...mapActions({
      findByIdCadastro: 'cadastro/findByIdCadastro',
      salvar: 'cadastroRetificacao/salvarCadastro',
      encerrarRetificacaoCancelamento: 'processo/encerrarRetificacaoCancelamento',
      finalizar: 'cadastroRetificacao/finalizarRetificacao',
      findIdProcesso: 'processo/findIdProcessoByProtocolo',
      excluirCadastroEmRetificacao: 'cadastroRetificacao/excluirCadastroEmRetificacao',
      cancelarRetificacao: 'cadastroRetificacao/cancelarRetificacao'
    }),

    mergeCadastro (cadastro) {
      cadastro.json = JSON.parse(cadastro.json)
      if (this.isRetificacao) {
        this.cadastro = {
          ...cloneDeep(cadastro.json),
          ...pickBy(cadastro, identity)
        }
      } else {
        this.cadastro = {
          ...cloneDeep(this.cadastroEmpty),
          ...pickBy(cadastro, identity)
        }
      }
      this.idCadastro = cadastro.id
    },

    formataRots () {
      return this.$route.path.includes('central') ? '' : this.$route.path.split('/')[1] + '/'
    },

    async validarCampos () {
      return this.$refs.observer.validate()
    },

    async validarCamposTab (label) {
      // workaround para contornar problema na validação do componente de telefone
      delete this.$refs.observer.refs['$ignoreTelefone$']

      let errors = []
      if (label) {
        errors = this.getErrosTab(label)
      }
      return errors
    },

    async proximo () {
      this.salvarCadastro()
      if (this.indexTabAtual === this.tabsFiltered.length - 1) {
        const tabsFiltered = this.tabs.filter(item => !item.isIntro && !item.isResumo)
        const promises = []
        for (let i = 1; i < tabsFiltered.length; i++) {
          promises.push(await this.$router.push({ name: this.tabs[i].name }))
        }

        Promise.all(promises)
      }

      const validate = await this.validarCampos()
      const errors = await this.validarCamposTab(this.tabs[this.indexTabAtual] ? this.tabs[this.indexTabAtual].label : null)
      if (!validate && errors.length > 0) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.VALIDATION_FAIL
        )
        return
      }
      if (this.isIntroPasso) {
        this.confirmBox(this.$messages.CONFIRMAR_DADOS_INFORMADOS, this.$messages.TITULO_WARNING,
          async () => {
            if (!validate) {
              this.showNotificacao(
                this.$messages.TIPO_WARNING,
                this.$messages.TITULO_WARNING,
                this.$messages.VALIDATION_FAIL
              )
              return
            }
            if (this.indexTabAtual !== this.tabs.length - 1) {
              this.navigate(this.indexTabAtual + 1)
            }
          },
          () => {})
      } else if (this.indexTabAtual !== this.tabs.length - 1) {
        this.navigate(this.indexTabAtual + 1)
      }
    },

    getRotaRetornoFinalizaRetificacao () {
      return this.$route.path.includes('central') ? 'central/processos' : 'central/processos'
    },

    async finalizarRetificacao () {
      try {
        this.isLoading = true
        if (this?.cadastro?.protocolo) {
          await this.encerrarRetificacaoCancelamento(this.cadastro.protocolo)
        }
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.DADOS_SALVOS_SUCESSO
        )
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )
        throw error
      } finally {
        this.isLoading = false
      }

      this.$router.push({
        name: this.getRotaRetornoFinalizaRetificacao()
      })
    },

    async salvarCadastro () {
      await this.validarCampos()

      try {
        this.isLoading = true
        if (!this.cadastro?.usuario) {
          this.cadastro = {
            ...this.cadastro,
            usuario: {
              id: null
            }
          }
        }
        this.cadastro.usuario.id = this.usuario.id

        this.cadastro.json = this.cadastroFormulario
        const response = await this.salvar(this.montarJson(this.idProcesso))
        this.mergeCadastro(response)

        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.DADOS_SALVOS_SUCESSO
        )
        this.isLoading = false

        if (this.$route.params.idCadastro === 'new') {
          this.$router.push({
            name: this.tabs[0].name,
            params: {
              idCadastro: this.cadastro.id
            }
          })
        }
      } catch (error) {
        this.isLoading = false
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )
        throw error
      }
    },

    montarJson (idProcessoByProtocolo) {
      const formulario = JSON.parse(this.cadastroJson.json)
      const jsonCadastro = {
        tipo: this.cadastroJson.tipo.codigo,
        versao: this.cadastroJson.versao,
        dados: {
          cadastro: this.cadastroFormulario ? this.cadastroFormulario : formulario.dados.cadastro
        }
      }
      return {
        id: null,
        json: JSON.stringify(jsonCadastro),
        idCadastro: this.cadastroJson.id,
        idProcesso: idProcessoByProtocolo
      }
    },

    voltar () {
      if (this.isPrimeiroPasso) {
        if (this.usuario.perfilSelecionado.codigo === 'RECEPTOR') {
          this.$router.push({
            name: 'receptor/listagem'
          })
        } else {
          this.$router.push({
            name: 'central/processos'
          })
        }
        return
      }

      const index = this.indexTabAtual - 1

      this.$router.push({
        name: this.tabs[index].name,
        params: {
          idCadastro: this.cadastro.id
        }
      })
    },

    cancelar () {
      if (this.isPa) {
        this.confirmBox('Você tem certeza que deseja cancelar? A retificação será cancelada e o status do processo não sofrera alterações.', this.$messages.TITULO_WARNING,
          async () => {
            if (this.usuario.hasPerfilExterno) {
              this.excluirCadastroEmRetificacao(this.idProcesso)
            } else {
              await this.cancelarRetificacao(this.idProcesso)
            }
            if (this.usuario.perfilSelecionado.codigo === 'RECEPTOR') {
              this.$router.push({
                name: 'receptor/listagem'
              })
            } else {
              this.$router.push({
                name: 'central/processos'
              })
            }
          },
          () => {
          }, 'Sim', 'Não')
      } else {
        this.confirmBox('Você tem certeza que deseja cancelar? Todos os dados serão perdidos.', this.$messages.TITULO_WARNING,
          () => {
            if (this.usuario.perfilSelecionado.codigo === 'RECEPTOR') {
              this.$router.push({
                name: 'receptor/listagem'
              })
            } else {
              this.$router.push({
                name: 'central/processos'
              })
            }
            this.excluirCadastroEmRetificacao(this.idProcesso)
          },
          () => {
          }, 'Sim', 'Não')
      }
    },

    openTermoCompromisso () {
      this.showTermoCompromisso = true
    },

    async finalizarCadastro () {
      this.showTermoCompromisso = false
      const formulario = this.montarJson(this.idProcesso)

      try {
        const response = await this.validarCampos()

        if (response) {
          try {
            await this.finalizar(formulario)

            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              'Cadastro criado com sucesso.'
            )

            if (this.usuario.perfilSelecionado.codigo === 'RECEPTOR') {
              this.$router.push({
                name: 'receptor/listagem'
              })
            } else {
              this.$router.push({
                name: 'central/processos'
              })
            }

            return
          } catch (error) {
            return
          }
        }

        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.ERRO_VALIDACAO_FINALIZAR_CADASTRO
        )
      } catch (error) {
        let message = error.message

        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          message
        )
      }
    },

    async mudarTab (componente) {
      // A lógica para evitar erro de validação na aba do interessado, que não está validando sem entrar na tela
      // Índices das abas Interessado e da aba selecionada
      let indexTabInteressado = this.tabs.findIndex((tab) => tab.name === 'retificacao/interessado')
      if (this.usuario.perfilSelecionado.codigo === 'RECEPTOR') {
        indexTabInteressado = this.tabs.findIndex((tab) => tab.name === 'receptor/retificacao/interessado')
      }

      const indexTabDestino = this.tabs.findIndex((tab) => tab.name === componente._props.name)

      // Prevenção de navegação redundante
      if (this.indexTabAtual === indexTabDestino) {
        return
      }

      try {
        // Primeiro, navega para a aba Interessado
        if (this.indexTabAtual !== indexTabInteressado) {
          await this.navigate(indexTabInteressado)

          // Valida os campos da aba Interessado
          await this.validarCamposTab(
            this.tabs[indexTabInteressado]?.label
          )
        }

        // Depois, navega para a aba destino
        if (indexTabDestino !== indexTabInteressado) {
          await this.navigate(indexTabDestino)
        }

        // Atualiza o índice atual
        this.indexTabAtual = indexTabDestino
      } catch (error) {
      }
    },

    tabPossuiErro (label) {
      let temErro = false
      if (this.$refs.observer) {
        for (const key in this.$refs.observer.errors) {
          if (key.substring(0, key.indexOf('/')) === label &&
            this.$refs.observer.errors[key].length > 0) {
            temErro = true
          }
        }
      }
      return temErro
    },

    getErrosTab (label) {
      let erros = []
      if (this.$refs.observer) {
        for (const key in this.$refs.observer.errors) {
          if (key.substring(0, key.indexOf('/')) === label &&
            this.$refs.observer.errors[key].length > 0) {
            const campo = key.substring(key.indexOf('/') + 1, key.length)
            erros.push(`${campo}: ${this.$refs.observer.errors[key][0]}`)
          }
        }
      }
      return erros
    },

    async navigate (indexTab) {
      if (indexTab === this.tabs.length - 1) {
        const validate = await this.validarCampos()
        if (!validate) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'Verifique os campos destacados antes de prosseguir'
          )
          return
        }
      }

      try {
        const formulario = this.montarJson(this.idProcesso)
        const response = await this.salvar(formulario)

        this.$router.push({
          name: this.tabs[indexTab].name,
          params: {
            idCadastro: response.id
          }
        })
      } catch (error) {
        throw error
      }
    },

    getLastEtapaByTipo (tipo) {
      const etapasEnds = new Map()

      etapasEnds.set('INFORMACOES', 'IMOVEL')
      etapasEnds.set('PERMUTA', 'GEORREFERENCIAMENTO')
      etapasEnds.set('AFORAMENTO', 'GEORREFERENCIAMENTO')
      etapasEnds.set('TRANSFERENCIA_DIREITOS', 'GEORREFERENCIAMENTO')
      etapasEnds.set('CANCELAMENTO_CLAUSULA_RESOLUTIVA', 'IMOVEL')
    }
  }

}

</script>

<style lang="scss" scoped>
$font-size-small: 12px;

h1 {
  font-size: 1.5rem;
  margin: 0;
}

.marginTitle {
  margin-top: 15px;
  margin-left: 5px;
}

.tab {
  font-size: 16px;
}

.container-cadastro {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
}

.content {
  flex: 1;
  padding: 20px;
}

.container-tab {
  padding: 10px;
}

pre {
  font-size: $font-size-small;
  line-height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/CadastroSicarfRetificacao.vue